import React from "react";
import { FormGroup } from "@cofano/cck";
import { Language } from "imports/Utils";
import { NstrGoodFragment } from "__generated__/view/products/graphql/product.fragments.generated";

export const ProductNstrDetails = ({ nstrGood }: { nstrGood?: NstrGoodFragment | null }) => {
	return (
		<React.Fragment>
			<FormGroup label={Language("PRODUCTS_NSTR_CODE")} overflow="hidden">
				{nstrGood?.nstrCode || "-"}
			</FormGroup>

			<FormGroup label={Language("PRODUCT_NSTR_CARGO_GROUP")} overflow="hidden">
				{nstrGood?.cargoGroup || "-"}
			</FormGroup>

			<FormGroup label={Language("PRODUCT_NSTR_DISCHARGE_IN_WATERWAY")} overflow="hidden">
				{nstrGood?.dischargingInWaterway || "-"}
			</FormGroup>

			<FormGroup label={Language("PRODUCT_NSTR_DISCHARGE_IN_SEWERS")} overflow="hidden">
				{nstrGood?.dischargingInSewers || "-"}
			</FormGroup>

			<FormGroup label={Language("PRODUCT_NSTR_SPECIAL_TREATMENT")} overflow="hidden">
				{nstrGood?.specialTreatment || "-"}
			</FormGroup>

			<FormGroup label={Language("PRODUCT_NSTR_REMARK")} overflow="visible">
				{nstrGood?.remark || "-"}
			</FormGroup>
		</React.Fragment>
	);
};

export default ProductNstrDetails;
